import { pxToRem } from '../../../../utils';
export var providerVariables = function providerVariables(siteVariables) {
  return {
    background: siteVariables.bodyBackground,
    color: siteVariables.bodyColor,
    scrollbarHeight: pxToRem(16),
    scrollbarWidth: pxToRem(16),
    scrollbarThumbBackgroundColor: siteVariables.colors.onyx[700],
    scrollbarThumbBorderRadius: pxToRem(9),
    scrollbarThumbBorderSize: pxToRem(4),
    scrollbarThumbHoverBackgroundColor: siteVariables.colors.onyx[700],
    scrollbarThumbHoverBorderSize: pxToRem(2)
  };
};
//# sourceMappingURL=providerVariables.js.map
